import api from '../api/axios';

const sendEtaNotification = (data) => {
  return api.post('/sms/send-eta', data);
};

const sendReviewRequest = (data) => {
  return api.post('/sms/send-review', data);
};

const sendProposalNotification = (data) => {
  return api.post('/sms/send-proposal', data);
};

const sendAmountDueSms = (data) => {
  return api.post('/sms/send-amount-due', data);
};

const sendReceiptSms = (data) => {
  return api.post('/sms/send-receipt', data);
};

const getLastReviewRequest = (clientId) => {
  return api.get(`/sms/last-review-request/${clientId}`);
};

const smsServices = {
  sendEtaNotification,
  sendReviewRequest,
  sendProposalNotification,
  sendAmountDueSms,
  sendReceiptSms,
  getLastReviewRequest,
};

export default smsServices;
